<!-- =========================================================================================
    File Name: BasketAdd.vue
    Description: 교재주문 - 상품목록
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div>
    <vx-card ref="filterCard" title="Filters" class="user-list-filters mb-8" actionButtons @refresh="onResetFilter">
      <div class="vx-row">
        <div class="vx-col md:w-1/3 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">브랜드명</label>
          <v-select :options="brandList" :clearable="false" v-model="brandName" name="item-brandName" class="mb-4 md:mb-0" />
        </div>
        <div class="vx-col md:w-1/3 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">코스명</label>
          <v-select :options="courseList" :clearable="false" v-model="courseName" class="mb-4 md:mb-0" />
        </div>
        <div class="vx-col md:w-1/3 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">레벨</label>
          <v-select :options="levelList" :clearable="false" v-model="level" class="mb-4 md:mb-0" />
        </div>
      </div>
    </vx-card>
    <div class="">
      <vs-alert :active="!validateForm" color="warning" icon-pack="feather" icon="icon-alert-triangle">
      주문할 교재를 선택해주세요.
      </vs-alert>
    </div>
    <vx-card class="mb-8">
      <div>
        <div class="vx-col w-full">
          <div class="mb-4 flex flex-wrap justify-between">
            <div class="mb-4 flex flex-wrap">
              <vs-input class="sm:mr-4" v-model="serverParams.keyword" @keyup.enter="onSearch" placeholder="교재명" />
              <vs-button color="primary" type="border" icon-pack="feather" icon="icon-search" @click="onSearch"></vs-button>
            </div>
            <div class="justify-end">
              <!-- <vs-button color="primary" :to="{name: 'basket-list'}">장바구니 바로가기</vs-button> -->
            </div>
          </div>
        </div>

        <vue-good-table
          ref="book-table"
          mode="remote"
          isLoading.sync="isLoading"
          @on-selected-rows-change="selectionChanged"
          @on-page-change="onPageChange"
          @on-per-page-change="onPerPageChange"
          :pagination-options="{
            enabled: true,
            dropdownAllowAll: false,
            nextLabel: '',
            prevLabel: '',
            rowsPerPageLabel: '',
            perPage: 10
          }"
          :select-options="{
            enabled: false,
            selectOnCheckboxOnly: false, // only select when checkbox is clicked instead of the row
            selectionInfoClass: 'custom-class',
            selectionText: 'rows selected',
            clearSelectionText: 'clear',
            disableSelectInfo: true, // disable the select info panel on top
            selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
          }"
          :columns="columns"
          :rows="rows"
          :totalRows="totalRecords"
          :fix-header="true"
          :line-numbers="false"
          styleClass="vgt-table condensed"
          >
          
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'action'">
              <!-- <vs-button size="small" type="border" @click="putBasket(props.row)">담기</vs-button> -->
              <vs-button size="small" color="primary" type="flat" icon-pack="feather" icon="icon-shopping-cart" @click="putBasket(props.row)">담기</vs-button>
            </span>
            <span v-else>
              {{props.formattedRow[props.column.field]}}
            </span>
          </template>

          </vue-good-table>
      </div>
    </vx-card> 

  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table'
import { fetchData, postData } from '@/api/module'
import vSelect from 'vue-select'

const defaultBrand = {label: '[브랜드명]', value: ''}
const defaultCourse = {label: '[코스명]', value: ''}
const defaultLevel = {label: '[레벨]', value: ''}

export default {
  components: {
    VueGoodTable,
    vSelect
  },
  watch: {
    brandName () {
      this.courseList = [defaultCourse]
      this.levelList = [defaultLevel]
      this.courseName = defaultCourse
      this.level = defaultLevel
      this.loadCourseList()
      this.loadItems()
    },
    courseName () {
      this.levelList = [defaultLevel]
      this.level = defaultLevel
      this.loadLevelList()
      this.loadItems()
    },
    level () {
      this.loadItems()
    }
  },   
  data () {
    return {
      isLoading: false,
      brandList: [defaultBrand],
      courseList: [defaultCourse],
      levelList: [defaultLevel],
      brandName: defaultBrand,
      courseName: defaultCourse,
      level: defaultLevel,
      instituteSeq: this.$store.getters.getUserInfo.instituteSeq,
      userID: this.$store.getters.getUserInfo.userID,
      productSeq: '',
      product_data: [],
      selectedRows: [],
      productList: [],
      columns: [
        {
          label: 'No.',
          field: 'productSeq',
          type: 'name',
          sortable: false
        },
        {
          label: '브랜드',
          field: 'brandName',
          type: 'name',
          sortable: false
        },
        {
          label: '코스',
          field: 'courseName',
          type: 'name',
          sortable: false
        },
        {
          label: '레벨',
          field: 'levelName',
          type: 'name',
          sortable: false
        },
        {
          label: '교재명',
          field: 'productName',
          type: 'name',
          sortable: false
        },
        {
          label: '교재코드',
          field: 'productCode',
          type: 'name',
          sortable: false
        },
        {
          label: '판매가',
          field: 'price',
          formatFn: this.price,
          type: 'name',
          sortable: false
        },
        {
          label: '장바구니',
          field: 'action',
          sortable: false
        }
      ],
      rows: [],
      totalRecords: 0,
      serverParams: {
        page: 1,
        perPage: 10
        // field: 'ProductSeq',
        // type: 'ASC'
      }
    }
  },
  computed: {
    validateForm () {
      if (this.selectedRows.length === 0) {
        return false
      } else {
        return true
      }
    }
  },
  methods: {
    onResetFilter () {
      this.brandName = defaultBrand
      this.courseName = defaultCourse
      this.level = defaultLevel
      this.$refs.filterCard.removeRefreshAnimation()
    },
    
    price (value) {
      return `${String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ',')  }원`
    },

    updateParams (newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps)
    },

    onPageChange (params) {
      this.serverParams.page = params.currentPage
      this.loadItems()
    },

    onPerPageChange (params) {
      this.serverParams.perPage = params.currentPerPage
      this.serverParams.page = 1
      this.loadItems()
    },

    onSearch () {
      this.serverParams.page = 1
      this.loadItems()
    },

    onCourseChanged () {
      this.levelList = [defaultLevel]
      this.level = defaultLevel
      this.loadLevelList()
      this.loadItems()
    },
    onLevelChanged () {
      this.loadItems()
    },
    async loadItems () { 

      try {
        this.serverParams = Object.assign(this.serverParams, {brandName: this.brandName.value})
        this.serverParams = Object.assign(this.serverParams, {courseName: this.courseName.value})
        this.serverParams = Object.assign(this.serverParams, {level: this.level.value})
        const { data } = await fetchData('product', this.serverParams)
        this.$vs.loading.close()
        this.totalRecords = data.count
        this.rows = data.list 

      } catch (error) {

        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }    
    },
    async loadBrandList () { 

      try {
        const { data } = await fetchData('product-brand')
        data.list.splice(0, 0, defaultBrand)
        this.brandList = data.list

      } catch (error) {

        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }    
    },
    async loadCourseList () { 

      try {
        const { data } = await fetchData('product-course', {brandName: this.brandName.value})
        data.list.splice(0, 0, defaultCourse)
        this.courseList = data.list

      } catch (error) {

        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }    
    },
    async loadLevelList () { 

      try {
        const { data } = await fetchData('product-level', {brandName: this.brandName.value, courseName: this.courseName.value})
        data.list.splice(0, 0, defaultLevel)
        this.levelList = data.list

      } catch (error) {

        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }    
    },
    
    putBasket (params) {
      this.save(params)
    },

    async save (params) {

      try {
        
        await postData('order/basket', {
          branchSeq : 1,
          instituteSeq : this.instituteSeq,
          userID : this.userID,
          productSeq: params.productSeq,
          orderCount: 1
        })
        this.$store.dispatch('loadCartItems', this.userID)
        this.showSaveSuccess()

      } catch (error) {

        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    },
    showSaveSuccess () {
      this.$vs.notify({
        color: 'success',
        title: '장바구니',
        text: '장바구니에 담았습니다.'
      })
    },

    selectionChanged () {
      this.selectedRows = this.$refs['book-table'].selectedRows
      this.product_data = this.selectedRows
    }

  },
  created () {
    this.loadItems()
    this.loadBrandList()
  }
}
</script>
